export default "__VITE_ASSET__CPbap$d8__"